var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.UslugeZaSeminarski,"item-text":"Ime","item-value":"UpisPO_ID","label":_vm.$t('documents.upload.available_services')},on:{"change":function($event){return _vm.odabir(_vm.odabranaUsluga)}},model:{value:(_vm.odabranaUslugaKljuc),callback:function ($$v) {_vm.odabranaUslugaKljuc=$$v},expression:"odabranaUslugaKljuc"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b19bb54e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./VueSrc/SeminarTask/components/SeminarUploadSelect.vue
// module id = 891
// module chunks = 0